
import { Component, Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { Subject } from 'rxjs';
import { I18NService } from '../base-i18n/services/i18n.service';

@Injectable({
  providedIn: 'root'
})
export class FormDrawerService {
  data$:any = {};

  constructor(private drawerService: NzDrawerService, private i18nService: I18NService) {

  }

  /**
   *
   * @param formContent  //The drawer body content
   * @param formTitle  .//The title for Drawer.
   * @param formValues // //The component inputs the param / The Template context
   */
  openDrawerForm(formContent: any, formTitle: any, formValues?: any, cachedData?: any, index?: number) {
    this.data$[formTitle] = new Subject<any>();
    if (cachedData) {
      formValues = { ...formValues, ...cachedData }
    }

    const drawerRef = this.drawerService.create<Component, { value: string }, string>({
      nzTitle: formTitle,
      nzContent: formContent,
      nzPlacement: this.i18nService.currentLang === 'ar-EG' ? 'right' : 'left',
      nzWidth: '1110px',
      nzHeight: '415px',
      nzOffsetY: 0,
      nzMaskClosable: false,
      nzContentParams: {
        value: formValues
      }
    });

    drawerRef.afterOpen.subscribe();

    drawerRef.afterClose.subscribe((data:any) => {
      if (data) {
        data["flag"] = formTitle;
        data["index"] = index;
        this.data$[formTitle].next(data);
        delete this.data$[formTitle];
      }
    });

    return this.data$[formTitle];
  }
}
